import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ArrowRight, TrendingUp } from 'lucide-react';

gsap.registerPlugin(useGSAP);

export default function Hero() {
  const container = useRef();
  const titleRef = useRef();
  const descriptionRef = useRef();
  const buttonsRef = useRef();
  const eyebrowRef = useRef();

  useGSAP(() => {
    const tl = gsap.timeline({ delay: 0.3 });
    
    tl.from(eyebrowRef.current, {
      opacity: 0,
      y: 20,
      duration: 0.6,
      ease: "power2.out"
    })
    .from(titleRef.current, {
      opacity: 0,
      y: 40,
      duration: 0.8,
      ease: "power2.out"
    }, "-=0.3")
    .from(descriptionRef.current, {
      opacity: 0,
      y: 30,
      duration: 0.7,
      ease: "power2.out"
    }, "-=0.4")
    .from(buttonsRef.current.children, {
      opacity: 0,
      y: 20,
      duration: 0.5,
      stagger: 0.15,
      ease: "power2.out"
    }, "-=0.3");
  }, { scope: container });

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" ref={container} className="hero-section">
      <div className="hero-background"></div>
      <div className="hero-content">
        <div ref={eyebrowRef} className="hero-eyebrow">
          Government Proposal Excellence
        </div>
        <h1 ref={titleRef} className="hero-title">
          Win More Contracts with Strategic Proposal Development
        </h1>
        <p ref={descriptionRef} className="hero-description">
          IronQuill Consulting provides end-to-end proposal lifecycle support—from capture strategy to final submission—helping government contractors, consulting firms, and startups increase their win probability.
        </p>
        <div ref={buttonsRef} className="hero-buttons">
          <button className="btn-primary" onClick={() => scrollToSection('contact')}>
            Start Your Proposal <ArrowRight size={20} />
          </button>
          <button className="btn-secondary" onClick={() => scrollToSection('services')}>
            Explore Services <TrendingUp size={20} />
          </button>
        </div>
      </div>
    </section>
  );
}
